firebird.factory('videoToggleService', [
    '$rootScope',
    '$window',
    '$timeout',
    'logService',
    'localizationService',
    'notificationService',
    'configService',
    'videoroomService',
    'videoGlobalService',
    function (
        $rootScope,
        $window,
        $timeout,
        logService,
        localizationService,
        notificationService,
        configService,
        videoroomService,
        videoGlobalService
    ) {
        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoToggleService');

        var service = {
            initialize: initialize
        };

        var self;
        var pauseVideoOnBgTimer = null;
        var resumeVideoOnFgTimer = null;
        var lastPauseTime = []; // timestamps (Date.now()) and also remove any time which are older than 120000ms. and check for length.
        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // video toggle and video loss related code

            // toggle video or auto-pause video on poor network conditions. can be changed using URL param.
            self.videoToggle = true; // true (default) or false
            self.videoTogglePaused = { videos: false, content: false };
            self.videoLoss = null; // null (default), "pause", "prompt" (for pause), "prompt-none" (for no-op) or "prompt-stop" (for stop)

            self.videoLossPrompt = false; // whether the prompt is displayed, or last time it was closed.
            self.videoLossPromptInterval = Infinity;

            self.initVideoToggle = initVideoToggle;
            self.initVideoToggleAndLoss = initVideoToggleAndLoss;
            self.onShowHideOneVideo = onShowHideOneVideo;
            self.onShowHideRemoteVideos = onShowHideRemoteVideos;
            self.onPauseStartRemoteVideos = onPauseStartRemoteVideos;
            self.isVideoTogglePaused = isVideoTogglePaused;
            self.onVideoLossPublish = onVideoLossPublish;
            self.onVideoLossStop = onVideoLossStop;
            self.onVideoPublishHighCpu = onVideoPublishHighCpu;

            self.onVisibilityChange = onVisibilityChange;
            self.toggleVideoOnVisibilityChange = toggleVideoOnVisibilityChange;
            self.cleanupPauseVideoOnBgState = cleanupPauseVideoOnBgState;
            self.pauseOnBackgroundDefault = {
                enabled: false, // for video rx
                fileshare: false, // for file share tx
                listening: false, // whether we are listening for event
                paused: false,
                // delay for pausing video -- when app goes in background videos will not be paused
                // immediately we will wait for 5s (or configured time) to pause
                pauseAfter: 5000,
                resumeAfter: 0,
                // these configuration specify number of times pause video should be allowed in ms
                // in this case video can be paused 3(limit) times in 2(time) mins
                limit: 3,
                time: 120000
            };

            self.pauseOnBackground = Object.assign({}, self.pauseOnBackgroundDefault);
        }

        function initVideoToggle() {
            self.initVideoToggleAndLoss(
                configService.getClientValue('videoLoss') || 'prompt-none',
                configService.getClientValue('videoToggle')
            );
            initPauseVideoOnBackgound();
        }

        function initVideoToggleAndLoss(videoLoss, videoToggle) {
            if (!videoLoss || videoLoss === 'false') {
                self.videoLoss = null;
            } else if (videoLoss) {
                self.videoLoss = videoLoss;
            }

            self.videoToggle = videoToggle != 'false';
        }

        function initPauseVideoOnBackgound() {
            self.setConfigObjectFromValue(
                'pauseOnBackground',
                configService.getValue('pauseOnBackground'),
                self.pauseOnBackground,
                self.pauseOnBackgroundDefault
            );
            const oldValue = self.pauseOnBackground.listening;
            const newValue = self.pauseOnBackground.enabled || self.pauseOnBackground.fileshare;

            if (oldValue !== newValue) {
                self.pauseOnBackground.listening = newValue;
            }
            // add listener for detect if app is in background and pause video
            $window.document.addEventListener('visibilitychange', self.onVisibilityChange);
        }

        function onVisibilityChange(e, background) {
            if (background === undefined) {
                background = $window.document.visibilityState === 'hidden';
            }
            logger.log(
                'onVisibilityChange',
                `${!e ? 'From labs ' : ''}document.visibilityState=${
                    $window.document.visibilityState
                }, background=${background}`
            );
            onVisibilityChangeVideoRx(e, background);
            onVisibilityChangeFileShare(e, background);
        }

        function onVisibilityChangeFileShare(e, appInBackground) {
            if (!self.pauseOnBackground.fileshare) {
                return;
            }

            if (appInBackground && self.fileVideo) {
                logger.log('videoroomCtrl - app background detected while sharing video');

                try {
                    self.fileVideo.pause();
                    notificationService.tryShowDesktopNotification(
                        localizationService.translate('SCREENSHARE.YOUR_VIDEO_HAS_BEEN_PAUSED')
                    );
                } catch (e) {
                    logger.error('onVisibilityChangeFileShare', 'Error trying to pause video playback', e);
                }
            }
        }

        function onVisibilityChangeVideoRx(e, appInBackground) {
            if (
                !self.pauseOnBackground.enabled ||
                self.isCompactMode ||
                (self.layoutPopout && Object.keys(self.popoutData.windows).length > 0)
            ) {
                return;
            }
            let timeNow = new Date().toLocaleTimeString();
            const { paused, pauseAfter, resumeAfter, time, limit } = self.pauseOnBackground;
            if (appInBackground) {
                const now = Date.now();
                if (resumeVideoOnFgTimer) {
                    logger.log('onVisibilityChange', 'clearResumeVideoTimeout');
                    clearResumeVideoTimeout();
                }
                // remove all items from lastPauseTime when first element is older than configured time
                if (lastPauseTime[0] && now - lastPauseTime[0] >= time) {
                    logger.log('onVisibilityChange', 'reset lastPauseTime');
                    lastPauseTime = [];
                }
                logger.log('onVisibilityChange', 'creating pauseVideoOnBgTimer ' + pauseAfter);
                pauseVideoOnBgTimer = $timeout(() => {
                    pauseVideoOnBgTimer = null;
                    // check if number of times video paused is greater than limit then do not proceed.
                    if (lastPauseTime.length < limit) {
                        const now = Date.now();
                        lastPauseTime.push(now);
                    } else {
                        logger.log('onVisibilityChange', `Video paused ${lastPauseTime.length} times in ${time}`);
                        return;
                    }
                    timeNow = new Date().toLocaleTimeString();
                    // when app is background and limit is not reached then pause remote videos
                    logger.log('onVisibilityChange', `${timeNow} hide videos ${!self.videoTogglePaused.videos}`);
                    self.toggleVideoOnVisibilityChange(!self.videoTogglePaused.videos, true);
                }, pauseAfter);
            } else {
                // when app is in foreground
                // if timer is set then videos were not paused as specified delay was not reached
                // so we just need to clear timeout
                // else videos have been paused and need to be resumed
                if (pauseVideoOnBgTimer) {
                    logger.log('onVisibilityChange', `${timeNow} clearPauseVideoTimeout`);
                    clearPauseVideoTimeout();
                }
                if (self.pauseOnBackground.paused) {
                    logger.log('onVisibilityChange', 'creating resumeVideoOnBgTimer ' + resumeAfter);
                    resumeVideoOnFgTimer = $timeout(() => {
                        timeNow = new Date().toLocaleTimeString();
                        resumeVideoOnFgTimer = null;
                        logger.log('onVisibilityChange', `${timeNow} show videos ${paused}`);
                        self.toggleVideoOnVisibilityChange(paused, false);
                    }, resumeAfter);
                } else {
                    logger.log('onVisibilityChange', 'not starting resumeVideoOnFgTimer as not paused');
                }
            }
        }

        function toggleVideoOnVisibilityChange(toggleVideo, pause) {
            if (toggleVideo) {
                self.pauseOnBackground.paused = pause !== undefined ? pause : !self.pauseOnBackground.paused;
                self.onPauseStartRemoteVideos();
            }
        }

        function clearPauseVideoTimeout() {
            if (pauseVideoOnBgTimer) {
                $timeout.cancel(pauseVideoOnBgTimer);
                pauseVideoOnBgTimer = null;
            }
        }

        function clearResumeVideoTimeout() {
            if (resumeVideoOnFgTimer) {
                $timeout.cancel(resumeVideoOnFgTimer);
                resumeVideoOnFgTimer = null;
            }
        }

        function cleanupPauseVideoOnBgState(ignoreEvent) {
            if (!self.pauseOnBackground.enabled && !self.pauseOnBackground.fileshare) {
                return;
            }
            if (!ignoreEvent) {
                $window.document.removeEventListener('visibilitychange', self.onVisibilityChange);
            }
            clearPauseVideoTimeout();
            clearResumeVideoTimeout();
        }

        function onShowHideOneVideo(id, div) {
            if ((!self.videoToggle && !self.videoLoss) || !div || !div.remoteFeed) {
                logger.warn(
                    'onShowHideOneVideo',
                    'ignoring showhide-one-video, videoToggle not enabled, not remote feed or not ready'
                );
                return;
            }

            if (div.remoteFeed.paused) {
                // do restart
                delete div.remoteFeed.paused;
                div.removeAttribute('paused');
                self.pauseVideoPlay(div.remoteFeed, false);
            } else {
                // do pause
                div.remoteFeed.paused = true;
                div.setAttribute('paused', 'true');
                self.pauseVideoPlay(div.remoteFeed, true);
            }

            logger.log('videoroomCtrl - showhide-one-video id=' + id + ', paused=' + !!div.remoteFeed.paused);
        }

        function onShowHideRemoteVideos(is_screen) {
            if (!self.videoToggle) {
                logger.warn('onShowHideRemoteVideos', 'ignoring showhide-remote-videos, videoToggle not enabled');
                return;
            }

            var type = is_screen ? 'content' : 'videos';
            var value = (self.videoTogglePaused[type] = !self.videoTogglePaused[type]);
            logger.log('videoroomCtrl - showhide-remote-videos, is_screen=' + is_screen + ', paused=' + value);

            if (self.layoutPage) {
                // TODO: avoid duplicate
                $window.$('#videoroom-videos > div.remote[user]').each(function (index, div) {
                    div.removeAttribute('paused'); // use enable instead of pause

                    var screen = !!div.className.match(/\bscreen\b/);
                    if (screen == is_screen) {
                        if (value) {
                            div.isPaused = true;
                        } else {
                            delete div.isPaused;
                        }
                    }
                });
            } else {
                for (var id in self.feeds) {
                    if (typeof self.feeds[id] === 'object') {
                        var remoteFeed = self.feeds[id];
                        var screen = !!remoteFeed.isScreen;
                        if (is_screen == screen) {
                            if (self.mediapath === 'sfu') {
                                remoteFeed.send({ message: { request: 'configure', audio: true, video: !value } });
                            } else {
                                self.pauseVideoPlay(remoteFeed, value);
                            }
                        }
                    }
                }

                $window.$('#videoroom-videos > div.remote[user]').each(function (index, div) {
                    div.removeAttribute('paused'); // use enable instead of pause
                    var screen = !!div.className.match(/\bscreen\b/);
                    if (screen == is_screen) {
                        if (value) {
                            if (div.getAttribute('enable') == 'true') {
                                div.setAttribute('enable', 'false');
                                div.isPaused = true;
                            }
                        } else {
                            if (div.getAttribute('enable') == 'false') {
                                delete div.isPaused;
                                div.setAttribute('enable', 'true');

                                // when show videos we need to reattach correct stream with video track
                                if (!$window.$(div).hasClass('audioonly') && div.savedSrcObject) {
                                    self.reattachStreamWithVideoTrack(div.getAttribute('user'), div);
                                }
                            }
                        }
                    }
                });
            }

            if (!is_screen && value && self.layoutPage && self.layoutPageData.layout == 'allhands') {
                // switch grid, as allhands cannot be shown with no videos.
                logger.log('videoroomCtrl - showhide-remote-videos, switch to grid from allhands');
                self.layoutPageData.layout = 'grid';
                $rootScope.$broadcast('change-videoroom-layout', { newLayout: videoroomService.layouts.GALLERY });
            } else {
                if (self.layoutPage && !self.layoutPageData.animateToggle) {
                    self.disableAnimationOnAllVideos(function () {
                        self.updateVideosLayout();
                    });
                } else {
                    self.updateVideosLayout();
                }
            }
        }

        // this function logic is similar to that in onShowHideRemoteVideos to show/hide videos,
        // except that it keeps the video box, but only pauses/stops the video
        function onPauseStartRemoteVideos() {
            if (!self.pauseOnBackground.enabled) {
                logger.warn('onPauseStartRemoteVideos', 'ignoring, pauseOnBackground is not enabled');
                return;
            }

            const value = self.pauseOnBackground.paused;
            logger.log('onPauseStartRemoteVideos', 'paused=' + value);
            const videoDivs = $window.$('#videoroom-videos > div.remote[user]:not(.screen)');
            if (self.layoutPage) {
                videoDivs.each(function (index, div) {
                    self.pauseVideoPlay(div.remoteFeed, value);
                });
            } else {
                for (var id in self.feeds) {
                    if (typeof self.feeds[id] === 'object') {
                        var remoteFeed = self.feeds[id];
                        if (!remoteFeed.isScreen) {
                            if (self.mediapath === 'sfu') {
                                remoteFeed.send({ message: { request: 'configure', audio: true, video: !value } });
                            } else {
                                self.pauseVideoPlay(remoteFeed, value);
                            }
                        }
                    }
                }
            }

            togglePausedAttr(value, videoDivs);
        }

        function togglePausedAttr(value, videoDivs) {
            videoDivs.each(function (index, div) {
                if (value) {
                    if (!div.hasAttribute('paused')) {
                        div.setAttribute('paused', 'true');
                        div.isPaused = true;
                    }
                } else {
                    if (div.getAttribute('paused') == 'true') {
                        delete div.isPaused;
                        div.removeAttribute('paused');
                    }
                }
            });
        }

        function isVideoTogglePaused(is_screen) {
            return is_screen ? self.videoTogglePaused.content : self.videoTogglePaused.videos;
        }

        function onVideoPublishHighCpu() {
            if (self.videoroom && self.videoLossPrompt !== true) {
                self.videoLossPrompt = true;

                logger.log('videoroomCtrl - onVideoPublishHighCpu showing prompt');
                self.msgflowEvent('prompt:high-cpu', {});

                const msgTitle = localizationService.translate('SETTINGS.CPU.DETECTED_HIGH_CPU_TITLE');
                const msgText = localizationService.translate('SETTINGS.CPU.DETECTED_HIGH_CPU_TEXT');
                const okText = localizationService.translate('SETTINGS.CPU.DETECTED_HIGH_CPU_TURN_OFF_WEBCAM');

                self.showAlert(
                    msgTitle,
                    msgText,
                    false,
                    function (confirmed) {
                        if (confirmed) {
                            self.msgflowEvent('confirm:high-cpu', {});
                            self.videoLossPrompt = false;
                            logger.log('videoroomCtrl onVideoPublishHighCpu stopping video');
                            $rootScope.$broadcast('stop-sfu-videopublish');
                        } else {
                            self.msgflowEvent('cancel:high-cpu', {});
                            self.videoLossPrompt = Date.now();
                            logger.log('videoroomCtrl onVideoPublishHighCpu not stopping video.');
                        }
                    },
                    {
                        okText,
                        imageUrl: 'img/redesign/modal/info.svg',
                        customClass: 'security-notification-modal auto-size'
                    }
                );
            } else {
                logger.log('onVideoPublishHighCpu', `event ignored ${self.videoLossPrompt}`);
            }
        }

        function onVideoLossPublish(noPrompt) {
            if (self.videoLoss == 'pause') {
                self.onVideoLossStop(true);
            } else if (!noPrompt && self.videoLoss && self.videoLoss.startsWith('prompt')) {
                // prompt, prompt-stop, prompt-none
                //This has an interval of infinity but used to be two minutes,
                // we removed the 2 min interval so if the user clicks on the cancel button then they won't be prompted with the alert again
                //after clicking cancel on the prompt.
                if (
                    (self.videoroom && self.videoLossPrompt === false) ||
                    (typeof self.videoLossPrompt === 'number' &&
                        Date.now() >= self.videoLossPrompt + self.videoLossPromptInterval)
                ) {
                    self.videoLossPrompt = true;
                    logger.log('videoroomCtrl - onVideoLossPublish showing prompt');
                    self.msgflowEvent('prompt:poor-network', {});
                    const msgTitle = localizationService.translate('SETTINGS.BANDWIDTH.DETECTED_LOW_BANDWIDTH_TITLE');
                    const msgText = localizationService.translate('SETTINGS.BANDWIDTH.DETECTED_LOW_BANDWIDTH_TEXT');
                    const okText = localizationService.translate(
                        'SETTINGS.BANDWIDTH.DETECTED_LOW_BANDWIDTH_TURN_OFF_WEBCAM'
                    );

                    self.showAlert(
                        msgTitle,
                        msgText,
                        false,
                        function (confirmed) {
                            if (confirmed) {
                                self.msgflowEvent('confirm:poor-network', {});
                                self.videoLossPrompt = false;
                                self.onVideoLossStop();
                            } else {
                                self.msgflowEvent('cancel:poor-network', {});
                                self.videoLossPrompt = Date.now();
                                logger.log(
                                    'videoroomCtrl onVideoLossPublish not stopping video. Will not prompt again since user canceled'
                                );
                            }
                        },
                        {
                            okText,
                            imageUrl: 'img/redesign/modal/info.svg',
                            customClass: 'security-notification-modal auto-size'
                        }
                    );
                }
            } else {
                logger.log('onVideoLossPublish', `event ignored, videoLoss=${self.videoLoss}, noPrompt=${noPrompt}`);
            }
        }

        function onVideoLossStop(prompt) {
            if (self.videoLoss) {
                if (self.videoroom) {
                    logger.log('videoroomCtrl onVideoLossPublish stopping video');
                    $rootScope.$broadcast('stop-sfu-videopublish');

                    if (!self.toggleVideoPaused) {
                        if (self.videoLoss == 'prompt-stop') {
                            // stop
                            if (!self.isVideoTogglePaused(false)) {
                                $rootScope.$broadcast('sfu-stopped-videos-on-loss'); // so that headerCtrl can update UI.
                                self.onShowHideRemoteVideos(false);
                            }
                        } else if (self.videoLoss != 'prompt-none') {
                            // pause
                            $window
                                .$('#videoroom-videos > div.remote[user][enable="true"]')
                                .each(function (index, div) {
                                    if (div.remoteFeed && !div.remoteFeed.paused) {
                                        div.remoteFeed.paused = true;
                                        div.setAttribute('paused', 'true');
                                        self.pauseVideoPlay(div.remoteFeed, true);
                                    }
                                });
                        }
                    }

                    if (prompt) {
                        self.showAlert(
                            'Video Stopped',
                            'Your video is stopped due to poor network condition. When the condition improves, please re-enable your camera and/or click on other attendee video to restart.'
                        );
                    }
                } else {
                    logger.log('videoroomCtrl onVideoLossPublish not attached to videoroom');
                }
            }
        }
    }
]);
